import { render, staticRenderFns } from "./ClaimBalanceNode.vue?vue&type=template&id=82990744"
import script from "./ClaimBalanceNode.vue?vue&type=script&lang=js"
export * from "./ClaimBalanceNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports